<div mat-dialog-title class="dialog-title p-3 pr-5" *ngIf="dialogRef">
  <h5>{{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
  <p class="m-0"><small>{{ sssp.site.location }}</small></p>
</div>

<hr class="m-0 p-0" *ngIf="dialogRef">

<mat-dialog-content class="p-0" *ngIf="dialogRef else tabs">
  <ng-container *ngIf="!sssp.id else tabs"></ng-container>
</mat-dialog-content>

<ng-template #tabs>
  <mat-tab-group (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Loading" *ngIf="!sssp.id">
      <div class="p-3">
        <p>Please wait while we load your {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}.</p>
      </div>
    </mat-tab>

    <mat-tab label="Settings" *ngIf="sssp.id && !sssp.contractor_id">
      <app-sssp-config *ngIf="sssp.id" [sssp_hash]="sssp.sssp_hash"></app-sssp-config>
    </mat-tab>

    <mat-tab label="Documents" *ngIf="sssp.id">
      <app-sssp-docs *ngIf="sssp.id" [sssp]="sssp" [sssp_hash]="sssp.sssp_hash"></app-sssp-docs>
    </mat-tab>

    <mat-tab label="{{ utils.getLangTerm('safety-plans.snapshots.plural', 'Snapshots') }}" *ngIf="sssp.id && !sssp.contractor_id">
      <app-sssp-snapshots #ssspSnapshotsComponent *ngIf="sssp.id" [sssp_hash]="sssp.sssp_hash"></app-sssp-snapshots>
    </mat-tab>
  </mat-tab-group>
</ng-template>
